import { render, staticRenderFns } from "./ScriptList.vue?vue&type=template&id=5b294500"
import script from "./ScriptList.vue?vue&type=script&lang=js"
export * from "./ScriptList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports